import { render } from "./AccountManageListForm.vue?vue&type=template&id=f4badfb2&lang=true"
import script from "./AccountManageListForm.vue?vue&type=script&lang=js"
export * from "./AccountManageListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__